<template>
  <footer>
    <div class="footer__meta">
      <div class="footer__lockup">
        <a href="https://www.smuckerawayfromhome.com/" data-gtmcat="OCS Engagement" data-gtmaction="click" data-gtmlabel="Main Site">
          Learn more about Smucker Away From Home <span>></span>
        </a>
        <div class="footer__jms-logo">
           <img src="/AwayFromHome/Global/Logos/AFH-Primary-Logo.png" alt="Smucker Away From Home" />
        </div>
      </div>
      <div class="copy">
        &copy;/&trade;/&reg; The J.M. Smucker Company.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Header'
}
</script>
<style lang="scss">
footer {
  background-color: white;
  text-align: center;
}

.footer__logo {
  background-color: #fff;;
  padding: 2em;
  @media screen and (min-width: 768px){
    // padding: 1.5em;
    padding: 3em;
  }
  img {
    width: 118px;
    margin: 0 auto;
    @media screen and (min-width: 768px){
      width: 168px;
    }
    @media screen and (min-width: 1200px){
      width: 205px;
    }
  }
}

.footer__meta {
  padding: 1.5em 1em;
  @media screen and (min-width: 768px){
    // padding: 1.5em;
    padding: 2em 2em 1em 2em;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;
  }
}
.footer__lockup {
  a {
    font-family: $sans;
    font-size: 13px;
    color: black;
    font-weight: bold;
    span {
      display: none;
      @include breakpoint(large){
        display: inline;
        margin-left: 3px;
      }
    }
  }
  @media screen and (min-width: 768px){
    display: flex;
    // flex-direction: row-reverse;
    align-items: flex-end;
  }
}

.footer__jms-logo {
  width: 120px;
  margin: 2em auto 3em auto;
  @media screen and (min-width: 768px){
    margin: 0 0 0 1em;
  }
}

.copy {
  font-family: $sans;
  margin: 0 auto;
  font-size: 10px;
  color: black;
  text-align: center;
  line-height: 1.75;
  a {
    color: black;
    padding: 1.5em 1em 0 1em;
    text-decoration: underline;
    display: block;
  }
  @media screen and (min-width: 768px){
    margin: 0 2em 0 0;
  }
}
</style>